import {
  IonButtons,
  IonCard,
  IonFabButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonSpinner,
  IonTextarea,
} from "@ionic/react";
import { sendOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import UserAvatar from "../../../components/UserAvatar";
import { setDocumentCommentText } from "../../../store/documentUpdate";
import { addDocumentComment } from "../../../store/documentUpdate/actions/addDocumentComment";
import { selectAddCommentStatus } from "../../../store/documentUpdate/selectors/selectAddCommentStatus";
import { selectAddCommentText } from "../../../store/documentUpdate/selectors/selectAddCommentText";

export const DocumentCommentBox = () => {
  const dispatch = useDispatch();
  const commentStatus = useSelector(selectAddCommentStatus);

  const text = useSelector(selectAddCommentText);

  const handleSubmit = async () => {
    await dispatch(addDocumentComment());
    dispatch(setDocumentCommentText(""));
  };

  return (
    <IonCard className="ion-no-padding ion-no-margin ion-padding-vertical">
      <IonItem lines="none">
        <UserAvatar />
        <IonLabel position="stacked">
          <h3>Escribe tu comentario</h3>
        </IonLabel>
        <IonTextarea
          value={text}
          placeholder="Comienza escribiendo..."
          onIonChange={(e) => {
            dispatch(setDocumentCommentText(e.detail.value!));
          }}
          disabled={commentStatus === "pending"}
          debounce={800}
        />
        <IonButtons slot="end">
          <IonFabButton
            size="small"
            color="primary"
            onClick={() => handleSubmit()}
            class="ion-align-self-start"
            disabled={!text || commentStatus === "pending"}
          >
            {commentStatus !== "pending" && <IonIcon size="small" icon={sendOutline} />}
            {commentStatus === "pending" && <IonSpinner name="dots" />}
          </IonFabButton>
        </IonButtons>
      </IonItem>
    </IonCard>
  );
};
